module.exports = __webpack_public_path__ + "img/match_type.0effbc5.svg";